// extracted by mini-css-extract-plugin
export default {"outlineContain":"PageNav_outlineContain__ONLtS","pageNavBox":"PageNav_pageNavBox__3FL+H","boardList":"PageNav_boardList__l7pFs","boardActive":"PageNav_boardActive__GN9W+"};